import React, { createContext, useContext } from 'react';

const RadioGroupContext = createContext();

export const RadioGroup = ({ value, onValueChange, className = '', children, ...props }) => {
  return (
    <RadioGroupContext.Provider value={{ value, onValueChange }}>
      <div className={`grid gap-2 ${className}`} {...props}>
        {children}
      </div>
    </RadioGroupContext.Provider>
  );
};

export const RadioGroupItem = ({ value, id, className = '', ...props }) => {
  const context = useContext(RadioGroupContext);
  const isChecked = context.value === value;
  
  return (
    <button
      type="button"
      role="radio"
      aria-checked={isChecked}
      onClick={() => context.onValueChange(value)}
      className={`aspect-square h-4 w-4 rounded-full border border-gray-300 text-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 ${
        isChecked ? 'border-blue-600' : ''
      } ${className}`}
      {...props}
    >
      {isChecked && (
        <div className="flex items-center justify-center">
          <div className="h-2 w-2 rounded-full bg-blue-600" />
        </div>
      )}
    </button>
  );
};
